import React, { useState, useContext } from 'react';
import UserContext from '../../context/Globales/UserContext';
import {
    Typography,
    makeStyles,
    TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Button, Grid, Modal, Fade, Backdrop
} from '@material-ui/core';
import { v4 as uuid } from 'uuid';

import IcpdfMorosidadModal from '../pdf/IC/IcpdfMorosidadModal';
import moment from 'moment';

const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
})



const useStyles = makeStyles((theme) => ({
    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '10px',
        fontWeight: '250',
        fontSize: '16px'
    },
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main,
        minWidth: 200,
        color: 'white',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },
    FondoTable: {

        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
    },
    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
      },
}));

const TblMorosidadModal = () => {
    const classes = useStyles();
    const { datoICMODAL } = useContext(UserContext);

    const [DatosDetalleImpagosMoroso] = useState(datoICMODAL.RegistrosMorosidadesYProtestos?.Morosidades);
    const [DatosDetalleImpagosMorosoSinacofiModal] = useState(datoICMODAL.RegistrosMorosidadesYProtestos?.MorosidadesSinacofi);
    const [OpenModalpdfMorosidad, setOpenModalpdfMorosidad] = React.useState(false); 

    const OpenModalpdf =()=>{
        setOpenModalpdfMorosidad(!OpenModalpdfMorosidad); 
    }; 

    const CloseModalPdf=()=>
    {
        setOpenModalpdfMorosidad(false); 

    }

    return (
        <div>


            {/*MODAL PDF INFORME COMER*/}

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalpdfMorosidad}
                onClose={CloseModalPdf}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalpdfMorosidad}>

                    <div className={classes.paperPdf}>


                        <IcpdfMorosidadModal />



                    </div>

                </Fade>
            </Modal>




            <h6 className={classes.tituloTable}>Detalle de Morosidades</h6>
            <br />
            {datoICMODAL.DetallesMorosidadesYProtestos?.Morosidades!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={OpenModalpdf}>Descargar PDF</Button></div> : ''}
            <br />
            {datoICMODAL.DetallesMorosidadesYProtestos?.Morosidades == null ? <h2>Cargando información...</h2> : ''}
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
            >
                <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                    <TableContainer >

                        <Table>

                            <TableHead className={classes.FondoTable}>

                                <TableRow >
                                    <TableCell>Cant. Documentos:  </TableCell>
                                    <TableCell>Fecha más reciente</TableCell>
                                    <TableCell>Monto total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >

                                    <TableCell>{datoICMODAL.DetallesMorosidadesYProtestos?.Morosidades?.NumeroDocumentos}</TableCell>
                                    <TableCell>{datoICMODAL.DetallesMorosidadesYProtestos?.Morosidades?.FechaMasReciente}</TableCell>
                                    <TableCell align="right"><strong> {datoICMODAL.DetallesMorosidadesYProtestos?.Morosidades?.MontoTotal}</strong></TableCell>
                                </TableRow>

                            </TableBody>


                        </Table>
                    </TableContainer>
                </Grid>



            </Grid>


            <TableContainer className={classes.containerTable}>
                <Table>
                    <TableHead className={classes.FondoTable}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Tipo Doc.</TableCell>
                            <TableCell>F. Venc.</TableCell>
                            <TableCell>Moneda</TableCell>
                            <TableCell>Monto.</TableCell>
                            <TableCell>Librador.</TableCell>
                            <TableCell>Tipo de deudad</TableCell>
                            <TableCell>Localidad.</TableCell>


                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {DatosDetalleImpagosMoroso.map((datadetalleMorosidad, idmorosidad) => (


                            <TableRow key={uuid()}>
                                <TableCell>{idmorosidad + 1}</TableCell>
                                <TableCell>{datadetalleMorosidad.TipoDocumento}</TableCell>
                                <TableCell>{datadetalleMorosidad.FechaVencimientoProtesto}</TableCell>
                                <TableCell> {datadetalleMorosidad.Moneda}</TableCell>
                                <TableCell align="right"> {datadetalleMorosidad.Moneda} {datadetalleMorosidad.Monto}</TableCell>
                                <TableCell>{datadetalleMorosidad.Librador}</TableCell>
                                <TableCell>{datadetalleMorosidad.TipoDeuda}</TableCell>
                                <TableCell>{datadetalleMorosidad.Localidad}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>
           
           
            <h6 className={classes.tituloTable}>Detalle de Morosidades Sinacofi</h6>
           
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
            >
                <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                    <TableContainer >

                        <Table>

                            <TableHead className={classes.FondoTable}>

                                <TableRow >
                                    <TableCell>Cant. Documentos:  </TableCell>
                                    <TableCell>Fecha más reciente</TableCell>
                                    <TableCell>Monto total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >

                                    <TableCell>{datoICMODAL.Resumenes?.MorosidadConsolidadaSinacofi?.TotalDocumentos}</TableCell>
                                    <TableCell>--</TableCell>
                                    <TableCell align="right">--</TableCell>
                                </TableRow>

                            </TableBody>


                        </Table>
                    </TableContainer>
                </Grid>



            </Grid>


            <TableContainer className={classes.containerTable}>
                <Table>
                    <TableHead className={classes.FondoTable}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Tipo Doc.</TableCell>
                            <TableCell>F. Venc.</TableCell>
                            <TableCell>Meneda.</TableCell>
                            <TableCell>Monto.</TableCell>
                            <TableCell>Librador.</TableCell>
                            <TableCell>Tipo de deudad</TableCell>
                            <TableCell>Localidad.</TableCell>


                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {DatosDetalleImpagosMorosoSinacofiModal.map((datadetalleMorosidad, idmorosidad) => (


                            <TableRow key={uuid()}>
                                <TableCell>{idmorosidad + 1}</TableCell>
                                <TableCell>{datadetalleMorosidad.TipoDocumento}</TableCell>
                                <TableCell>{moment(datadetalleMorosidad.FechaVencimientoProtesto).format('DD/MM/YYYY')}</TableCell>
                                <TableCell> {datadetalleMorosidad.Moneda}</TableCell>
                                <TableCell align="right"> {datadetalleMorosidad.Moneda} {datadetalleMorosidad.Monto}</TableCell>
                                <TableCell>{datadetalleMorosidad.Librador}</TableCell>
                                <TableCell>{datadetalleMorosidad.TipoDeuda}</TableCell>
                                <TableCell>{datadetalleMorosidad.Localidad ? datadetalleMorosidad.Localidad : '--'  }</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>

        </div>
    )

}

export default TblMorosidadModal
